"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CAMERATYPE = void 0;
var CAMERATYPE;
(function (CAMERATYPE) {
    CAMERATYPE["PERSPECTIVE"] = "perspective";
    CAMERATYPE["ORTHOGRAPHIC"] = "orthographic";
})(CAMERATYPE = exports.CAMERATYPE || (exports.CAMERATYPE = {}));
//# sourceMappingURL=ICameraEngine.js.map